import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useManifiestos } from '../../hooks/useManifest';
import ManifiestosDashboard from '../../components/administracion/ManifestDashboard';

const ManifiestosPage = () => {
  const { manifiestos, isLoading, error } = useManifiestos();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Error al cargar manifiesto.</Alert>;

  return (
    <Box sx={{ p: 2 }}>
      <ManifiestosDashboard
        windows={manifiestos}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de manifiestos:', newOrder);
        }}
      />
    </Box>
  );
};

export default ManifiestosPage;